import { StepType } from "@redotech/redo-model/advanced-flow/steps";
import { abTestStepType } from "./ab-test";
import { blockCheckoutStepType } from "./block-checkout/block-checkout";
import { checkoutExperienceStepType } from "./checkout-experience/checkout-experience";
import { conditionStepType } from "./condition";
import { doNothingStepType } from "./do-nothing";
import { downsellStepType } from "./downsell";
import { FrontendStepType } from "./index";
import { manageCustomerTagsStepType } from "./manage-customer-tags";
import { manageStaticSegmentStepType } from "./manage-static-segment";
import { omsActionStepType } from "./oms/oms-action";
import { omsConditionStepType } from "./oms/oms-condition";
import { postPurchasePageStepType } from "./post-purchase-page/post-purchase-page";
import { postPurchaseSegmentStepType } from "./post-purchase-segment/post-purchase-segment";
import { postPurchaseSplitStepType } from "./post-purchase-split/post-purchase-split";
import { processReturnStepType } from "./process-return";
import { rcoCheckoutPackageStepType } from "./rco-checkout-package";
import { rcoCheckoutPackageConditionStepType } from "./rco-checkout-package-condition";
import { rcoSegmentStepType } from "./rco-segment/rco-segment";
import { rcoSplitStepType } from "./rco-split/rco-split";
import { recoverStepType } from "./recover";
import { ruleActionsStepType } from "./rules/rule-actions-step";
import { ruleConditionsStepType } from "./rules/rule-conditions-step";
import { ruleConditionsV3StepType } from "./rules/rule-conditions-v3-step";
import { sendEmailStepType } from "./send-email";
import { sendSmsStepType } from "./send-sms";
import { sendWebhookStepType } from "./send-webhook";
import { trackingPageStepType } from "./tracking-page/tracking-page";
import { triggerStepType } from "./trigger";
import { upsellStepType } from "./upsell";
import { upsellConditionStepType } from "./upsell-condition";
import { waitStepType } from "./wait";
import { waitForEventStepType } from "./wait-for-event";
import { workOrderConditionStepType } from "./work-order/work-order-condition";
import { workOrderWorkStepType } from "./work-order/work-order-work-step";

export const stepTypes: Record<StepType, FrontendStepType<any>> = {
  [StepType.DO_NOTHING]: doNothingStepType,
  [StepType.WAIT]: waitStepType,
  [StepType.WAIT_FOR_EVENT]: waitForEventStepType,
  [StepType.CONDITION]: conditionStepType,
  [StepType.SEND_SMS]: sendSmsStepType,
  [StepType.SEND_EMAIL]: sendEmailStepType,
  [StepType.SEND_WEBHOOK]: sendWebhookStepType,
  [StepType.MANAGE_CUSTOMER_TAGS]: manageCustomerTagsStepType,
  [StepType.MANAGE_STATIC_SEGMENT]: manageStaticSegmentStepType,
  [StepType.RECOVER]: recoverStepType,
  [StepType.TRIGGER]: triggerStepType,
  [StepType.UPSELL]: upsellStepType,
  [StepType.DOWNSELL]: downsellStepType,
  [StepType.UPSELL_CONDITION]: upsellConditionStepType,
  [StepType.OMS_ACTION]: omsActionStepType,
  [StepType.OMS_CONDITION]: omsConditionStepType,
  [StepType.AB_TEST]: abTestStepType,

  // Checkout tree
  [StepType.RCO_SPLIT]: rcoSplitStepType,
  [StepType.CHECKOUT_EXPERIENCE]: checkoutExperienceStepType,
  [StepType.RCO_SEGMENT]: rcoSegmentStepType,
  [StepType.BLOCK_CHECKOUT]: blockCheckoutStepType,

  // Checkout packages
  [StepType.RCO_CHECKOUT_PACKAGE]: rcoCheckoutPackageStepType,
  [StepType.RCO_CHECKOUT_PACKAGE_CONDITION]:
    rcoCheckoutPackageConditionStepType,

  // Post-purchase
  [StepType.POST_PURCHASE_PAGE]: postPurchasePageStepType,
  [StepType.POST_PURCHASE_SEGMENT]: postPurchaseSegmentStepType,
  [StepType.POST_PURCHASE_SPLIT]: postPurchaseSplitStepType,

  // Tracking page
  [StepType.TRACKING_PAGE]: trackingPageStepType,

  // Support rules
  [StepType.RULE_CONDITIONS]: ruleConditionsStepType,
  [StepType.RULE_ACTIONS]: ruleActionsStepType,
  [StepType.RULE_CONDITIONS_V3]: ruleConditionsV3StepType,
  [StepType.RULE_ACTIONS_V3]: ruleActionsStepType,

  // Work order flows
  [StepType.WORK_ORDER_WORK_STEP]: workOrderWorkStepType,
  [StepType.WORK_ORDER_CONDITION]: workOrderConditionStepType,

  // Return processing flows
  [StepType.PROCESS_RETURN]: processReturnStepType,
};
